// extracted by mini-css-extract-plugin
export default {"loading-mochi":"loading-mochi_loading-mochi__PNrLQ","show":"loading-mochi_show__rOdHw"};